(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Initialize every carousel inside a featured collection root
    const roots = document.querySelectorAll('.featured-collection--root');

    roots.forEach((root) => {
        const carousel = root.querySelector('.carousel');
        const container = root.querySelector('.carousel-container') || (carousel && carousel.parentElement);
        if (!carousel || !container) return;

        // Per-carousel state
        let isDragging = false;
        let startPositionX = 0;
        let currentTranslateX = 0;
        let previousTranslateX = 0;
        let currentX = 0;
        let moved = false;
        const MOVE_THRESHOLD = 8; // pixels

        // Initial styles and prevent native drag
        carousel.style.cursor = 'grab';
        carousel.addEventListener('dragstart', (e) => e.preventDefault());

        // Mouse events
        carousel.addEventListener('mousedown', dragStart);
        // document.addEventListener('mousemove', dragging);
        // document.addEventListener('mouseup', dragEnd);
        carousel.addEventListener('mousemove', dragging);
        carousel.addEventListener('mouseup', dragEnd);

        // Touch events
        carousel.addEventListener('touchstart', touchStart, { passive: true });
        // document.addEventListener('touchmove', touchMove, { passive: false });
        // document.addEventListener('touchend', dragEnd);
        carousel.addEventListener('touchmove', touchMove, { passive: false });
        carousel.addEventListener('touchend', dragEnd);

        window.addEventListener('touchend', dragEnd);
        window.addEventListener('mouseup', dragEnd);
        window.addEventListener('blur', dragEnd);

        let startPositionY = 0;
        let isVerticalScroll = false;

        function touchStart(e) {
            startPositionX = e.touches[0].clientX;
            startPositionY = e.touches[0].clientY;
            currentX = startPositionX;
            isVerticalScroll = false;
            dragStart(e);
        }

        function touchMove(e) {
            if (isVerticalScroll) return;

            const touchX = e.touches[0].clientX;
            const touchY = e.touches[0].clientY;
            
            // Calculate horizontal and vertical distance moved
            const deltaX = Math.abs(touchX - startPositionX);
            const deltaY = Math.abs(touchY - startPositionY);

            // If we haven't determined the direction yet
            if (!moved) {
                // If vertical movement is greater than horizontal, let the page scroll
                if (deltaY > deltaX && deltaY > MOVE_THRESHOLD) {
                    isVerticalScroll = true;
                    isDragging = false;
                    return;
                }
                
                // If horizontal movement is significant, prevent vertical scroll
                if (deltaX > MOVE_THRESHOLD) {
                    e.preventDefault();
                }
            }

            currentX = touchX;
            dragging(e);
        }

        function dragStart(e) {
            if (e.type === 'mousedown') {
                startPositionX = e.clientX;
                currentX = e.clientX;
            }

            isDragging = true;
            moved = false;
            carousel.style.cursor = 'grabbing';
            carousel.style.transition = 'none';
        }

        function dragging(e) {
            if (!isDragging) return;

            // if (e.cancelable) e.preventDefault();
            if (e.cancelable && e.target.closest('.carousel')) {
            e.preventDefault();
            }

            const clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : (e.clientX || currentX);
            const diff = clientX - startPositionX;

            moved = Math.abs(diff) > MOVE_THRESHOLD;

            currentTranslateX = previousTranslateX + diff;

            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            if (currentTranslateX > maxTranslate) currentTranslateX = maxTranslate;
            if (currentTranslateX < minTranslate) currentTranslateX = minTranslate;

            carousel.style.transform = `translateX(${currentTranslateX}px)`;
        }

        function dragEnd() {
            if (!isDragging) return;

            isDragging = false;
            carousel.style.cursor = 'grab';
            carousel.style.transition = 'transform 0.3s ease-out';

            // Snap to nearest item on drag end
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10; // fallback 10px
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const step = itemWidth + gap;

            // compute closest index
            const rawIndex = Math.round(Math.abs(currentTranslateX) / step);
            const targetTranslate = -rawIndex * step;

            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            // clamp target
            const finalTranslate = Math.min(maxTranslate, Math.max(minTranslate, targetTranslate));

            currentTranslateX = finalTranslate;
            previousTranslateX = currentTranslateX;

            // apply snapping transform
            carousel.style.transform = `translateX(${currentTranslateX}px)`;

            if (moved) {
                // keep moved true briefly so the following click can be suppressed
                setTimeout(() => { moved = false; }, 200);
            }
            // update arrows opacity/state after snapping
            updateButtonsVisibility();
        }

        // Navigation buttons (per carousel)
        // Check if buttons already exist in this container
        let prevButton = container.querySelector('.navigation-button.prev-button');
        let nextButton = container.querySelector('.navigation-button.next-button');

        // Only create buttons if they don't exist
        if (!prevButton) {
            prevButton = document.createElement('button');
            prevButton.className = 'navigation-button prev-button';
            prevButton.innerHTML = '←';
            container.appendChild(prevButton);
        }

        if (!nextButton) {
            nextButton = document.createElement('button');
            nextButton.className = 'navigation-button next-button';
            nextButton.innerHTML = '→';
            container.appendChild(nextButton);
        }

        prevButton.addEventListener('click', () => {
            // move by one item width + gap
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10;
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const moveAmount = itemWidth + gap;

            currentTranslateX = Math.min(currentTranslateX + moveAmount, 0);
            carousel.style.transition = 'transform 0.3s ease-out';
            carousel.style.transform = `translateX(${currentTranslateX}px)`;
            previousTranslateX = currentTranslateX;
            updateButtonsVisibility();
        });

        nextButton.addEventListener('click', () => {
            const firstItem = carousel.querySelector('.carousel-item');
            const gap = parseInt(getComputedStyle(carousel).gap || '10', 10) || 10;
            const itemWidth = firstItem ? firstItem.offsetWidth : Math.floor((container.offsetWidth - gap) / 2);
            const moveAmount = itemWidth + gap;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            currentTranslateX = Math.max(currentTranslateX - moveAmount, minTranslate);
            carousel.style.transition = 'transform 0.3s ease-out';
            carousel.style.transform = `translateX(${currentTranslateX}px)`;
            previousTranslateX = currentTranslateX;
            updateButtonsVisibility();
        });

        // Buttons are now added when created above

        // helper: toggle disabled class on arrows when at ends
        function updateButtonsVisibility() {
            const maxTranslate = 0;
            const minTranslate = -(carousel.scrollWidth - container.offsetWidth);

            if (currentTranslateX >= -1) {
                prevButton.classList.add('disabled');
                prevButton.setAttribute('aria-disabled', 'true');
            } else {
                prevButton.classList.remove('disabled');
                prevButton.setAttribute('aria-disabled', 'false');
            }

            if (currentTranslateX <= minTranslate + 1) {
                nextButton.classList.add('disabled');
                nextButton.setAttribute('aria-disabled', 'true');
            } else {
                nextButton.classList.remove('disabled');
                nextButton.setAttribute('aria-disabled', 'false');
            }
        }

        // initial state
        updateButtonsVisibility();

        // Suppress anchor clicks when a drag occurred (capture phase)
        root.addEventListener('click', (e) => {
            const anchor = e.target.closest && e.target.closest('a');
            if (!anchor) return;
            if (moved) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }, true);
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-collapsible-tabs"] && !Shopify.designMode) return;
  try {
    var accordionItems = new Array();

  function accordionsInit() {

    // Grab the accordion items from the page
    var divs = document.getElementsByTagName( 'div' );
    for ( var i = 0; i < divs.length; i++ ) {
      if ( divs[i].className == 'accordionItem' ) accordionItems.push( divs[i] );
    }

    // Assign onclick events to the accordion item headings
    for ( var i = 0; i < accordionItems.length; i++ ) {
      var h2 = getFirstChildWithTagName( accordionItems[i], 'H2' );
      h2.onclick = toggleItem;
    }

    // Hide all accordion item bodies, now not except the first one
    for ( var i = 0; i < accordionItems.length; i++ ) {
      accordionItems[i].className = 'accordionItem hide';
    }
  }

  function toggleItem() {
    var itemClass = this.parentNode.className;

    // Hide all items
    for ( var i = 0; i < accordionItems.length; i++ ) {
      accordionItems[i].className = 'accordionItem hide';
    }

    // Show this item if it was previously hidden
    if ( itemClass == 'accordionItem hide' ) {
      this.parentNode.className = 'accordionItem';
    }
  }

  function getFirstChildWithTagName( element, tagName ) {
    for ( var i = 0; i < element.childNodes.length; i++ ) {
      if ( element.childNodes[i].nodeName == tagName ) return element.childNodes[i];
    }
  }

  accordionsInit();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-collection-filters"] && !Shopify.designMode) return;
  try {
    class Navigation extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.current_width = window.innerWidth, "loading" === document.readyState ? window.on("DOMContentLoaded", () => this.load()) : this.load()
    }
    load() {
        this.initGrid(), 
        this.initNavigation(), 
        this.initFilter(), 
        this.navigationListener(), 
        this.checkEmptyState(),
        Shopify.designMode && this.sectionListeners()
    }
    initGrid() {
        this.body = document.querySelector("[data-body-root]"), 
        this.grid_container = this.body.querySelector("[data-body-grid]"), 
        this.max_columns = parseInt(this.body.getAttribute("data-max-columns")), 
        this.num_columns = parseInt(this.grid_container.getAttribute("data-columns")), 
        this.pagination = this.body.querySelector("[data-body-pagination]"), 
        this.pagination_link = this.body.querySelector("[data-body-pagination-link]"), 
        this.spinner = this.body.querySelector("[data-body-spinner]")
    }
    initNavigation() {
        this.active_price_tag = this.querySelector('.navigation--active-tag[data-type="price"]'), 
        this.active_min = this.active_price_tag.querySelector("[data-min-price]"), 
        this.active_max = this.active_price_tag.querySelector("[data-max-price]"), 
        this.active_refine_tag = this.querySelector('.navigation--active-tag[data-type="refine"]'), 
        this.active_sort_tag = this.querySelector('.navigation--active-tag[data-type="sort"]'), 
        this.active_tags_container = this.querySelector(".navigation--tags-container"), 
        this.active_tags_wrapper = this.querySelector(".navigation--active-tags"), 
        this.clear_tags_button = this.querySelector(".navigation--active-clear"), 
        this.layout_buttons = this.querySelectorAll(".navigation--layout-button"), 
        this.navigation_buttons = this.querySelectorAll(".navigation--button, .navigation--mobile-button"), 
        this.small_layout_button = this.layout_buttons[1], this.storage_name = this.getAttribute("data-storage-name"), 
        this.url = this.getAttribute("data-url"), 
        this.layout_buttons.length && 2 < this.max_columns ? (this.initLayout(), this.setLayout(), this.layoutListener()) : this.layout_buttons.forEach(t => t.style.display = "none")
    }

    initFilter() {
    this.filter = this.filter || this.parentNode.querySelector(".filter--root");

        if (this.filter) {
            if (window.innerWidth <= 767) {
                this.moveFilterToDrawer();
            }

            this.browse_links = this.filter.querySelectorAll('[data-type="browse"] .filter--label');
            this.current_sort_input = this.filter.querySelector('[data-type="sort"] .filter--input:checked');
            this.filter_form = this.filter.querySelector(".filter--form");
            this.menu_toggles = this.filter.querySelectorAll(".filter--toggle");
            this.price_range = this.filter.querySelector(".price-range--wrapper");
            this.refine_links = this.filter.querySelectorAll('[data-type="refine"] .filter--label');
            // this.reset_buttons = this.filter.querySelectorAll('.filter--button[data-type="reset"]');
            this.sort_links = this.filter.querySelectorAll('[data-type="sort"] .filter--label');
            this.swatch_inputs = this.filter.querySelectorAll('[data-is-swatches="true"] .filter--input');

            // Initialize toggle functionality only if filter toggle elements exist in the DOM
            if (window.innerWidth <= 767 && this.menu_toggles.length) {
                this.menuToggleListeners(); 
            }

            this.clearAllListener();

            if (this.browse_links.length) {
                this.browseListener();
            }

            if (this.sort_links.length) {
                if (this.current_sort_input) {
                    this.current_sort_link = this.current_sort_input.nextElementSibling;
                    this.current_sort_value = this.current_sort_input.value;
                    this.current_sort_label = this.current_sort_input.getAttribute("data-label");
                }

                this.sortListener();
                this.renderActiveSort();
                this.activeSortListener();
            }

            if (this.refine_links.length) {
                this.refineListener();

                if (this.swatch_inputs.length) {
                    theme.utils.setSwatchColors(this.swatch_inputs);
                }

                this.renderActiveRefines();
            }

            if (this.price_range) {
                this.renderActivePriceListener();
                this.getNewProductsListener();
                this.activePriceListener();
            }

            this.toggleActiveTags();
        }
    }

    sectionListeners() {
        window.on("shopify:section:load", () => {
            this.initGrid(), this.initNavigation(), this.initFilter(), theme.drawer.loadTriggers()
        })
    }
    navigationListener() {
        this.navigation_buttons.on("click keydown", ({
            key: t,
            target: e,
            type: i
        }) => {
            "keydown" === i && "Enter" !== t || this.toggleFilterMenu(e.getAttribute("data-toggle-menu"))
        })
    }
    toggleFilterMenu(e) {
        document.querySelectorAll(".filter--toggle").forEach(t => {
            t.setAttribute("aria-expanded", !1), t.nextElementSibling.setAttribute("data-transition-active", !1), t.getAttribute("aria-controls").includes(e) && t.click()
        })
    }
    initLayout() {
        this.layout_buttons.forEach(t => t.removeAttribute("style")), this.small_layout_button.setAttribute("data-column-size", this.max_columns)
    }
    setLayout() {
        let e = parseInt(localStorage.getItem(theme.local_storage[this.storage_name]));
        e && (2 === e || e === this.num_columns) || (e = this.num_columns, localStorage.setItem(theme.local_storage[this.storage_name], e)), this.grid_container.setAttribute("data-columns", e), this.layout_buttons.forEach(t => {
            t.setAttribute("data-active", !1), parseInt(t.getAttribute("data-column-size")) === e && t.setAttribute("data-active", !0)
        })
    }
    layoutListener() {
        this.layout_buttons.off("click keydown"), this.layout_buttons.on("click keydown", t => {
            var e;
            "keydown" === t.type && "Enter" !== t.key || (e = parseInt(t.target.getAttribute("data-column-size")), localStorage.setItem(theme.local_storage[this.storage_name], e), this.setLayout())
        })
    }
    moveFilterToDrawer() {
        var t = theme.drawer.querySelector('[data-view="filter"]');
        t.innerHTML = "", t.appendChild(this.filter), theme.drawer.loadTriggers()
    }
    menuToggleListeners() {
        console.log("menuToggleListeners initialized");

        this.menu_toggles.on("click keydown", t => {
            if ("keydown" !== t.type || "Enter" === t.key) {
                var e = t.target;
                const i = "true" !== e.getAttribute("aria-expanded"),
                    r = (e.setAttribute("aria-expanded", i), e.nextElementSibling);
                setTimeout(() => r.setAttribute("data-transition-active", i), 0)
            }
        })
    }
    clearAllListener() {
        // Existing button already present in the DOM
        if (this.clear_tags_button) {
            this.clear_tags_button.addEventListener("click", e => this.clearAll(e));

            this.clear_tags_button.addEventListener("keydown", e => {
                if (e.key === "Enter") this.clearAll(e);
            });
        }

        // Existing reset buttons inside the filter
        this.filter.querySelectorAll('.filter--button[data-type="reset"]').forEach(button => {
            button.addEventListener("click", e => this.clearAll(e));

            button.addEventListener("keydown", e => {
                if (e.key === "Enter") this.clearAll(e);
            });
        });

        // Delegated listener for reset buttons added dynamically later
        document.addEventListener("click", e => {
            const button = e.target.closest(".filter-reset");
            if (!button) return;

            this.clearAll(e);
        });

        document.addEventListener("keydown", e => {
            if (e.key !== "Enter") return;

            const button = e.target.closest(".filter-reset");
            if (!button) return;

            this.clearAll(e);
        });
    }
    clearAll(e) {
        this.current_sort_link && this.current_sort_link.click();

        window.trigger("theme:priceRange:clear");

        if (this.active_refine_tags && this.active_refine_tags.length) {
            this.active_refine_tags.forEach(tag => {
                tag.dispatchEvent(new Event("click", { bubbles: true }));
            });
        }

        e.target.focus();
    }
    checkEmptyState() {
        const emptyState = this.grid_container.querySelector(".collection--body--empty");

        if (emptyState) {
            this.grid_container.classList.add("is-empty");
        } else {
            this.grid_container.classList.remove("is-empty");
        }
    }
    browseListener() {
        this.browse_links.on("click keydown", i => {
            if ("keydown" !== i.type || "Enter" === i.key) {
                const r = i.target.previousElementSibling;
                let t = !1,
                    e;
                r.checked && (t = !0), setTimeout(() => {
                    e = t ? (r.checked = !1, theme.urls.all_products_collection) : r.value, location.href = "" + location.origin + e, setTimeout(() => theme.drawer.close(), 350)
                }, 0)
            }
        })
    }
    sortListener() {
        this.sort_links.on("click keydown", e => {
            if ("keydown" !== e.type || "Enter" === e.key) {
                const i = e.target,
                    r = i.previousElementSibling;
                let t = !1;
                r.checked && (t = !0), setTimeout(() => {
                    t ? (r.checked = !1, this.current_sort_link = !1, this.current_sort_label = !1, this.current_sort_value = !1) : (r.checked = !0, this.current_sort_link = i, this.current_sort_label = r.dataset.label, this.current_sort_value = r.value), this.showLoadingView(), this.renderActiveSort(), this.getAjaxUrl()
                }, 0)
            }
        })
    }
    refineListener() {
        this.refine_links.on("click keydown", event => {
            if (event.type === "keydown" && event.key !== "Enter") return;

            const label = event.currentTarget;
            const input = label.previousElementSibling;

            if (event.type === "keydown" && event.key === "Enter") {
                input.checked = !input.checked;
            }

            setTimeout(() => {
                const activeTags = this.active_tags_wrapper.querySelectorAll(
                    '.navigation--active-tag[data-type="refine"]'
                );

                if (activeTags.length) {
                    activeTags.forEach(tag => tag.remove());
                }

                //BBB filter selection tracking
                this.trackFilterSelection(input);

                this.showLoadingView();
                this.renderActiveRefines();
                this.getAjaxUrl();
            }, 0);
        });
    }
    trackFilterSelection(input) {
        // BBB - filter selection tracking
        if (!input || !input.checked) return;

        const filterValue = input.getAttribute("data-label");

        if (!filterValue) return;

        const getFilterType = name => {
          let type = name
            // Remove Shopify filter prefix:
            // filter.v.m.custom. / filter.p.m.custom. etc.
            .replace(/^filter\.[^.]+\.m\.custom\./, "")
            .replace(/^filter_/, "")
            .replace(/_/g, " ")
            .replace(/\b\w/g, char => char.toUpperCase());

          const mappings = {
            "Shades": "Shade"
          };

          return mappings[type] || type;
        };

        const filterType = getFilterType(input.name);

        const activeFilters = Array.from(
            this.filter.querySelectorAll('[data-type="refine"] input:checked')
        )
            .map(item => ({
                type: getFilterType(item.name),
                value: item.getAttribute("data-label")
            }))
            .filter(item => item.value);

        const filterCombination = activeFilters
            .map(item => `${item.type}:${item.value}`)
            .sort()
            .join("|");

        const trackingData = {
            event: "filter_applied",
            filter_type: filterType,
            filter_value: filterValue,
            filter_combination: filterCombination,
            active_filter_count: activeFilters.length,
            collection_handle: this.dataset.collectionHandle || "",
            collection_title: this.dataset.collectionTitle || ""
        };

        // console.log("[Filter Tracking]", trackingData);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(trackingData);
    }
    getNewProductsListener() {
        window.on("theme:navigation:loadNewProducts", () => {
            this.showLoadingView(), this.getAjaxUrl()
        })
    }
    getAjaxUrl() {
        var t = new FormData(this.filter_form),
            e = new URLSearchParams(t);
        this.ajax_url = "" + this.url + e.toString(), history.replaceState({}, "", this.ajax_url), this.getGridHtml(), this.toggleActiveTags()
    }
    showLoadingView() {

        // BBB - Scroll to the top of the product grid container after filters update the content
        const root = document.querySelector('[data-body-root]');
        if (root) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        this.grid_container.innerHTML = ""; 
        [this.grid_container, this.pagination].forEach(t => t.style.display = "none");
        this.spinner.style.display = "flex";
    }
    async getGridHtml() {
        this.abort_controller && this.abort_controller.abort(), this.abort_controller = new AbortController;
        try {
            if (this.response = await fetch(this.ajax_url, {
                    signal: this.abort_controller.signal
                }), !this.response.ok) throw new Error(response.statusText);
            var t = await this.response.text(),
                e = theme.utils.parseHtml(t, "[data-body-root]", ["predictive-search-root"]);

            this.renderGridHtml(e); 
            this.spinner.style.display = "none"; 

            this.grid_container.removeAttribute("style"); 

            //BBB INIT YOTPO AFTER PRODUCTS ARE RENDERED
            if (window.yotpoWidgetsContainer) {
                yotpoWidgetsContainer.initWidgets();
            }

            setTimeout(() => this.loadTransitions(), 0); 
            window.trigger("theme:navigation:reloaded")
        } catch {}
    }
    renderGridHtml(t) {
        var e = t.querySelector("[data-body-grid]").innerHTML,
            i = (this.grid_container.innerHTML = e,
            t.querySelector("[data-body-pagination]"));

        if (i) {
            this.pagination.innerHTML = i.innerHTML;
            this.pagination.removeAttribute("style");

            if (this.pagination_link) {
                this.pagination_link.style.display = "block";
            }
        } else if (this.pagination_link) {
            this.pagination_link.style.display = "none";
        }

        this.checkEmptyState();
    }
    loadTransitions() {
        [...this.grid_container.querySelectorAll("[data-transition-container]")].map(t => theme.transitions.load(t)), theme.transitions.reload(this.body.dataset.sectionId)
    }
    renderActiveSort() {
        this.current_sort_value ? (this.render_active_sort = !0, this.active_sort_tag.querySelector("span").textContent = this.current_sort_label, this.active_sort_tag.setAttribute("data-value", this.current_sort_value), this.active_sort_tag.removeAttribute("style")) : (this.render_active_sort = !1, this.active_sort_tag.style.display = "none")
    }
    renderActivePriceListener() {
        window.on("theme:priceRange:renderActive", ({
            detail: t
        }) => {
            0 === t.current_min && t.current_max === t.max ? (this.active_price_tag.style.display = "none", this.render_active_price = !1) : (this.render_active_price = !0, this.active_min.textContent = "" + t.current_min, this.active_max.textContent = "" + t.current_max, this.active_price_tag.removeAttribute("style")), this.toggleActiveTags()
        })
    }
    renderActiveRefines() {
        this.active_refine_tags = [], this.render_active_refine = !1;
        const i = {
            labels: [],
            names: [],
            swatches: [],
            values: []
        };
        if (this.filter.querySelectorAll('[data-type="refine"] input:checked').forEach(t => {
                i.labels.push(t.getAttribute("data-label")), i.names.push(t.name), i.values.push(t.value);
                var e = t.nextElementSibling;
                "swatch" === e.getAttribute("data-item") ? i.swatches.push(e.getAttribute("style")) : i.swatches.push(!1)
            }), 0 < i.values.length) {
            var t = new DocumentFragment;
            for (let e = 0; e < i.values.length; e++) {
                var r = this.active_refine_tag.cloneNode(!0),
                    s = (r.removeAttribute("style"), r.setAttribute("data-value", i.values[e]), r.setAttribute("data-name", i.names[e]), r.querySelector("span").textContent = i.labels[e], r.querySelectorAll('[data-item="swatch"]'));
                i.swatches[e] && s.length ? s.forEach(t => t.setAttribute("style", i.swatches[e])) : s.length && s.forEach(t => t.remove()), t.prepend(r), this.active_refine_tags.push(r)
            }
            this.active_tags_wrapper.prepend(t), this.render_active_refine = !0, this.activeRefineListeners()
        }
    }
    toggleActiveTags() {
        var t = this.render_active_refine || this.render_active_sort || this.render_active_price;
        this.active_tags_container.style.display = t ? "block" : "none"
    }
    activeSortListener() {
        this.active_sort_tag.on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || this.current_sort_link && this.current_sort_link.click()
        })
    }
    activePriceListener() {
        this.active_price_tag.on("click keydown", t => {
            "keydown" === t.type && "Enter" !== t.key || window.trigger("theme:priceRange:clear")
        })
    }
    activeRefineListeners() {
        this.active_refine_tags.on("click keydown", t => {
            if ("keydown" !== t.type || "Enter" === t.key) {
                const s = t.target;
                this.refine_links.forEach(t => {
                    var e = t.previousElementSibling,
                        i = s.getAttribute("data-value"),
                        r = s.getAttribute("data-name");
                    e.value === i && e.name === r && (t.click(), e.checked = !1)
                })
            }
        })
    }
}
customElements.define("collection-filters-root", Navigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-flexible-payments"] && !Shopify.designMode) return;
  try {
    function hideModal(button) {
      return function() {
        let close_btn = document.querySelector(".layout--close"); //grab the element
        close_btn.click();
        }
    };

    const buttons = document.querySelectorAll(".modal-close");
    buttons.forEach(button => button.addEventListener("click", hideModal(button)));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

      const searchToggles = document.querySelectorAll('.site-header__action--search, .header--search');
      const closeSearchButton = document.querySelector('.site-header__close-search');
      const layoutViewport = document.querySelector('.layout--viewport');
      const layoutMain = document.querySelector('.layout--main-content');

      searchToggles.forEach(toggle => {
          toggle.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent the default link behavior

            if (layoutViewport) {
                layoutViewport.setAttribute('data-drawer-status', 'closed');
                layoutViewport.removeAttribute('data-drawer-view');
                layoutViewport.removeAttribute('data-drawer-side');
                layoutMain.removeAttribute('style');
            }

              // Toggle the 'search--bar-active' class on the body
              document.body.classList.toggle('search--bar-active');

              // Focus on the input elements inside the search bar
              const inputHeader = document.querySelector('.cs-predictive-search input');
              setTimeout(() => {
                if (inputHeader) {
                    inputHeader.focus(); // Focus on the header input
                }
              }, 500);
          });
      });

      if (closeSearchButton) {
          closeSearchButton.addEventListener('click', function(e) {
              e.preventDefault(); // Prevent the default link behavior

              // Remove the 'search--bar-active' class from the body
              document.body.classList.remove('search--bar-active');

              // Select the viewport element
              const viewport = document.querySelector('.layout--viewport');
              if (viewport) {
                  viewport.setAttribute('data-drawer-status', 'closed'); // Set the drawer status
                  viewport.removeAttribute('data-drawer-view'); // Remove the drawer view attribute
                  viewport.removeAttribute('data-drawer-side'); // Remove the drawer side attribute
              }

              // Select the main content element and remove inline styles
              const mainContent = document.querySelector('.layout--main-content');
              if (mainContent) {
                  mainContent.removeAttribute('style'); // Remove the inline styles
              }
          });
      }
      
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-help-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-help-menu-button]');
  const chatLink = event.target.closest('[data-gorgias-chat]');

  if (chatLink) {
    event.preventDefault();

    if (window.GorgiasChat) {
      GorgiasChat.open();
    }

    return;
  }

  // Click on Need Help button
  if (button) {
    const menu = button.closest('[data-help-menu]');
    const dropdown = menu.querySelector('[data-help-menu-dropdown]');
    const isOpen = dropdown.classList.contains('show');

    // Close any other open Help menus
    document.querySelectorAll('[data-help-menu-dropdown].show').forEach((item) => {
      if (item !== dropdown) {
        item.classList.remove('show');

        const otherMenu = item.closest('[data-help-menu]');
        const otherButton = otherMenu?.querySelector('[data-help-menu-button]');

        if (otherButton) {
          otherButton.setAttribute('aria-expanded', 'false');
        }
      }
    });

    dropdown.classList.toggle('show', !isOpen);
    button.setAttribute('aria-expanded', String(!isOpen));

    return;
  }

  // Click outside -> close all Help menus
  if (!event.target.closest('[data-help-menu]')) {
    document.querySelectorAll('[data-help-menu-dropdown].show').forEach((dropdown) => {
      dropdown.classList.remove('show');

      const menu = dropdown.closest('[data-help-menu]');
      const menuButton = menu?.querySelector('[data-help-menu-button]');

      if (menuButton) {
        menuButton.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-main-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.clear_button = this.querySelector(".search--clear");
    this.input = this.querySelector(".search--textbox");
    this.results = this.querySelector(".search--results");
    this.cached_results = {
      "": this.results.innerHTML
    };

    this.updateBodySearchState();
    this.listenForKeyEntered();
    this.formSubmit();
    this.clearButtonListener();
    this.addMutationObserver();
  }

  initYotpo() {
    requestAnimationFrame(() => {
      if (
        typeof yotpoWidgetsContainer !== "undefined" &&
        typeof yotpoWidgetsContainer.initWidgets === "function"
      ) {
        yotpoWidgetsContainer.initWidgets();
      }
    });
  }

  updateBodySearchState() {
    const hasQuery = this.input.value.trim().length > 0;

    document.body.classList.toggle("search-has-query", hasQuery);
  }

  highlightSearchTerms(container, query) {
    if (!container || !query) return;

    const searchTerm = query.trim();

    if (!searchTerm) return;

    // Popular Searches (query) already uses Shopify's styled_text,
    // so highlight only the other predictive search resources.
    const titles = container.querySelectorAll(
      [
        '.predictive-search--item[data-type]:not([data-type="query"]) .title',
        '.predictive-search--product-grid .product--title'
      ].join(',')
    );

    const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedTerm})`, "gi");

    titles.forEach((title) => {
      const text = title.textContent;

      if (!regex.test(text)) return;

      regex.lastIndex = 0;

      title.innerHTML = text.replace(
        regex,
        "<strong>$1</strong>"
      );
    });
  }

  listenForKeyEntered() {
    this.input.on("input", () => {
      const query = this.input.value.trim();

      this.clear_button.style.display = query === "" ? "none" : "flex";

      this.updateBodySearchState();
      this.getSearchResults(query);
    });
  }

  async getSearchResults(query) {
    if (this.abort_controller) {
      this.abort_controller.abort();
    }

    const key = query.handleize();

    if (this.cached_results[key]) {
      this.results.innerHTML = this.cached_results[key];

      // this.highlightSearchTerms(this.results, query);

      // this.initYotpo();
    } else {
      this.abort_controller = new AbortController();
      this.toggleLoading(true);

      try {
        // BBB searching on default product fields: product title, product type, variant title, and vendor.
        // const response = await fetch(
        //   `${theme.urls.predictive_search}?q=${encodeURIComponent(query)}&section_id=predictive-search`,
        //   {
        //     signal: this.abort_controller.signal
        //   }
        // );

        // BBB searching on default product fields: product title, product type, variant title, vendor, tags and description.
        const params = new URLSearchParams({
          q: query,
          "resources[type]": "product,query,collection,page,article",
          "resources[limit]": "10",
          "resources[limit_scope]": "each",
          "resources[options][fields]":
            "title,product_type,variants.title,vendor,tag,body",
          "resources[options][unavailable_products]": "last",
          section_id: "predictive-search"
        });

        const response = await fetch(
          `${theme.urls.predictive_search}?${params.toString()}`,
          {
            signal: this.abort_controller.signal
          }
        );

        if (!response.ok) {
          throw new Error(response.status);
        }

        const html = await response.text();
        const results = theme.utils.parseHtml(html).innerHTML;

        this.cached_results[key] = results;
        this.results.innerHTML = results;

        // this.highlightSearchTerms(this.results, query);

        // this.initYotpo();
      } catch {}
    }
  }

  clearButtonListener() {
    this.clear_button.on("click keydown", (event) => {
      if (event.type === "keydown" && event.key !== "Enter") {
        return;
      }

      event.preventDefault();

      this.input.value = "";
      this.input.focus();
      this.input.trigger("input");
    });
  }

  toggleLoading(loading) {
    setTimeout(
      () => this.setAttribute("data-loading", loading),
      loading ? 0 : 100
    );
  }

  formSubmit() {
    this.form.on("submit", (event) => {
      event.preventDefault();

      window.location.href =
        theme.urls.search +
        "?type=product&q=" +
        encodeURIComponent(this.input.value.trim());
    });
  }

  addMutationObserver() {
    new MutationObserver(() => {
      this.toggleLoading(false);
      window.trigger("theme:search:reloaded");
      theme.transitions.reload("search");
    }).observe(this.results, {
      childList: true
    });
  }

}

customElements.define("predictive-search-root", PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-product-bundle-modal"] && !Shopify.designMode) return;
  try {
    function hideModal(button) {
      return function() {
        let close_btn = document.querySelector(".layout--close"); //grab the element
        close_btn.click();
        }
    };

    const buttons = document.querySelectorAll(".modal-close");
    buttons.forEach(button => button.addEventListener("click", hideModal(button)));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-product-card-buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

    // AddToCart button product card
    function handleClick(e){
      var btn = e.target.closest('.product-buy-buttons--primary');
      if (!btn) return;

      // if it's a smart payment secondary button, don't intercept
      if (btn.getAttribute('data-item') === 'secondary-button') return;

      var root = btn.closest('product-buy-buttons-root') || btn.closest('.product-buy-buttons--root');
      if (!root) return;

      e.preventDefault();

      if (btn.disabled) return;

      var select = root.querySelector('.product-buy-buttons--select');
      var variantId = select ? select.value : null;
      if (!variantId) return;

      //btn.setAttribute('aria-busy','true');
      //btn.disabled = true;

      var textEl = btn.querySelector('.product-buy-buttons--cta-text');
      textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(response){
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function(data){
        try { window.dispatchEvent(new CustomEvent('cart:ajaxAdd', { detail: data })); } catch(e){}

        var textEl = btn.querySelector('.product-buy-buttons--cta-text');
        var originalText = btn.getAttribute('data-text') || (textEl ? textEl.textContent : 'Added');
        if (textEl) textEl.textContent = 'Added';
        setTimeout(function(){ if (textEl) textEl.textContent = originalText; }, 1400);
      })
      .catch(function(err){
        if (err && typeof err.json === 'function') {
          err.json().then(function(j){ console.error('Add to cart error', j); });
        } else {
          console.error(err);
        }
      })
      .finally(function(){
        //btn.setAttribute('aria-busy','false');
        //btn.disabled = false;
      });
    }

    document.addEventListener('click', handleClick, { capture: false });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-product-options-bundle"] && !Shopify.designMode) return;
  try {
    (function() {
  const productCache = new Map();

  // Fetch product JSON by handle and cache it
  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const p = fetch(`/products/${handle}.js`).then(r => r.json());
    productCache.set(handle, p);
    return p;
  }

  // Find variant by option value (matches title or any option1/2/3)
  function findVariantByOption(product, optionValue) {
    return product.variants.find(v =>
      v.title === optionValue ||
      v.option1 === optionValue ||
      v.option2 === optionValue ||
      v.option3 === optionValue
    );
  }

  // Normalize Shopify CDN URLs (sometimes returned as //cdn...)
  function normalizeSrc(src) {
    if (!src) return null;
    return src.startsWith('//') ? 'https:' + src : src;
  }

  // Update bundle child image src and alt based on variant
  async function updateChildImage(container, optionValue) {
    const handle = container.dataset.handle;
    const imgEl = container.querySelector('img.bundle-product-image');
    if (!handle || !imgEl) return;

    try {
      const product = await fetchProduct(handle);
      if (!product || !product.variants || !product.variants.length) return;

      const variant = findVariantByOption(product, optionValue);
      if (!variant) {
        console.warn('Variant not found for:', optionValue, 'in', handle);
        return;
      }

      let src = normalizeSrc(variant.featured_image && variant.featured_image.src);
      if (src) src = src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/, '_300x$1');

      // fade-in when the actual image finishes loading
      //imgEl.style.opacity = 0;
      //imgEl.onload = () => { imgEl.style.opacity = 1; };

      imgEl.setAttribute('src', src);
      imgEl.setAttribute('alt', variant.title);
    } catch (e) {
      console.error('Error in updateChildImage:', e);
    }
  }

  // Initialize a single bundle-product block (idempotent)
  function initBundle(container) {
    if (!container || container.dataset.bundleInitialized === 'true') return;

    const handle = container.dataset.handle;
    const radios = container.querySelectorAll('.radios--input');
    if (!handle || !radios.length) return;

    // prefetch product JSON ASAP
    fetchProduct(handle).catch(() => {});

    // Initial update using checked or first radio
    const checked = container.querySelector('.radios--input:checked');
    const initialValue = checked ? checked.value : radios[0].value;
    updateChildImage(container, initialValue);

    // Update on radio change
    radios.forEach(radio => {
      radio.addEventListener('change', e => {
        updateChildImage(container, e.target.value);
      });
    });

    container.dataset.bundleInitialized = 'true';
  }

  // Initialize all current bundle-product blocks
  function initAllBundles() {
    document.querySelectorAll('.bundle-product[data-handle]').forEach(initBundle);
  }

  // Run immediately for any elements already in the DOM
  initAllBundles();

  // Also observe the DOM for late-inserted bundle blocks (no waiting for DOMContentLoaded)
  if (window.MutationObserver) {
    const obs = new MutationObserver(mutations => {
      for (const m of mutations) {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          // Direct match
          if (node.matches && node.matches('.bundle-product[data-handle]')) {
            initBundle(node);
          }
          // Or any matches within this subtree
          node.querySelectorAll && node.querySelectorAll('.bundle-product[data-handle]').forEach(initBundle);
        });
      }
    });

    // Observe as early as possible
    obs.observe(document.documentElement || document, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cs-sticky-atc')) {
    customElements.define(
      'cs-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          // Wait until this section's markup is complete, including editor reloads.
          this.initTimer = setTimeout(() => this.init(), 0);
        }

        init() {
          this.section = this.closest('.shopify-section');
          this.form = this.section?.querySelector('.product-page--form');
          this.sourceButton = this.form?.querySelector('.product-buy-buttons--primary');
          if (!this.sourceButton) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;
          this.media = window.matchMedia('(min-width: 768px)');
          this.submit = this.querySelector('.cs-sticky-atc__submit');
          this.price = this.querySelector('.cs-sticky-atc__price');
          this.rewards = this.querySelector('.cs-sticky-atc__rewards');
          this.rewardPoints = this.querySelector('[data-reward-points]');
          this.updateRewards(Number(this.rewards.dataset.price));
          this.image = this.querySelector('.cs-sticky-atc__image');
          this.fallbackImage = this.image?.src;
          this.sourcePrice = this.form.querySelector('.product-price--original');
          this.sourceOptions = this.form.querySelector('product-options-root');
          this.groups = [];
          this.buildOptions();

          this.submit.addEventListener(
            'click',
            () => {
              if (
                !this.sourceButton.disabled &&
                this.sourceButton.getAttribute('aria-busy') !== 'true'
              ) {
                this.sourceButton.click();
                this.sync();
              }
            },
            { signal }
          );

          this.form.addEventListener('change', () => this.queueSync(), { signal });
          if (this.sourceOptions) {
            window.addEventListener(
              `theme:product:${this.sourceOptions.dataset.id}:variantChanged`,
              (event) => {
                const variant = event.detail?.variant;
                this.updateRewards(variant?.price);
                if (this.image)
                  this.image.src = variant?.featured_image?.src || this.fallbackImage;
                this.queueSync();
              },
              { signal }
            );
          }

          this.observer = new MutationObserver(() => this.queueSync());
          this.observer.observe(this.sourceButton, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
          });
          if (this.sourcePrice)
            this.observer.observe(this.sourcePrice, {
              childList: true,
              subtree: true,
              characterData: true
            });
          if (this.sourceOptions)
            this.observer.observe(this.sourceOptions, {
              attributes: true,
              attributeFilter: [
                'checked',
                'disabled',
                'data-unavailable',
                'data-empty',
                'style',
                'class'
              ],
              subtree: true
            });

          this.intersection = new IntersectionObserver(() => this.updateVisibility());
          this.intersection.observe(this.sourceButton);
          this.media.addEventListener('change', () => this.updateVisibility(), { signal });
          document.addEventListener(
            'click',
            (event) => {
              if (!this.contains(event.target)) this.closeOptions();
            },
            { signal }
          );
          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape') {
                const open = this.querySelector('details[open]');
                this.closeOptions();
                open?.querySelector('summary').focus();
              }
            },
            { signal }
          );
          this.sync();
          this.updateVisibility();
        }

        buildOptions() {
          const container = this.querySelector('.cs-sticky-atc__options');
          container.replaceChildren();
          this.sourceOptions
            ?.querySelectorAll('.product-options--option')
            .forEach((source) => {
              const inputs = [...source.querySelectorAll('.radios--input')];
              if (!inputs.length) return;
              const name =
                source.querySelector('.radios--option-label')?.textContent.trim() ||
                'Option';
              const details = document.createElement('details');
              details.className = 'cs-sticky-atc__option';
              const summary = document.createElement('summary');
              summary.className = 'cs-sticky-atc__summary';
              const selectedSwatch = this.createSwatch();
              const selectedText = document.createElement('span');
              summary.append(selectedSwatch, selectedText);
              const choices = document.createElement('div');
              choices.className = 'cs-sticky-atc__choices';
              choices.setAttribute('role', 'group');
              choices.setAttribute('aria-label', name);
              const entries = inputs.map((input) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'cs-sticky-atc__choice';
                const swatch = this.createSwatch();
                const text = document.createElement('span');
                text.textContent = input.value;
                button.append(swatch, text);
                button.addEventListener(
                  'click',
                  () => {
                    input.click();
                    details.open = false;
                    summary.focus();
                    this.queueSync();
                  },
                  { signal: this.controller.signal }
                );
                choices.append(button);
                return { input, button, swatch };
              });
              details.append(summary, choices);
              details.addEventListener(
                'toggle',
                () => {
                  if (details.open)
                    this.groups.forEach((group) => {
                      if (group.details !== details) group.details.open = false;
                    });
                },
                { signal: this.controller.signal }
              );
              container.append(details);
              this.groups.push({
                details,
                summary,
                selectedSwatch,
                selectedText,
                entries,
                name
              });
            });
        }

        createSwatch() {
          const swatch = document.createElement('span');
          swatch.className = 'cs-sticky-atc__swatch';
          swatch.setAttribute('aria-hidden', 'true');
          return swatch;
        }

        copySwatch(input, target) {
          // Read the existing label: radios, grouped shades and variant images
          // already implement all product-specific swatch filename rules.
          const label = input.labels?.[0];
          const image = label?.querySelector(
            '.featured-image.show img, .featured-image img'
          );
          const isSwatch = label?.matches('[data-item="swatch"]');
          target.hidden = !isSwatch && !image;
          if (isSwatch) {
            const style = getComputedStyle(label);
            target.style.backgroundImage = style.backgroundImage;
            target.style.backgroundColor = style.backgroundColor;
          } else if (image) {
            target.style.backgroundImage = `url(${JSON.stringify(
              image.currentSrc || image.src
            )})`;
            target.style.backgroundColor = '#fff';
          }
        }

        updateRewards(price) {
          const hasPrice = Number.isFinite(price);
          this.rewards.hidden = !hasPrice;
          this.rewards.style.display = hasPrice ? '' : 'none';

          if (hasPrice) {
            this.rewardPoints.textContent = (price / 100).toLocaleString(
              document.documentElement.lang || 'en',
              { maximumFractionDigits: 2 }
            );
          }
        }

        queueSync() {
          cancelAnimationFrame(this.syncFrame);
          this.syncFrame = requestAnimationFrame(() => this.sync());
        }

        sync() {
          const busy = this.sourceButton.getAttribute('aria-busy') === 'true';
          this.submit.disabled = this.sourceButton.disabled || busy;
          this.submit.setAttribute('aria-busy', String(busy));
          this.submit.textContent = busy
            ? 'ADDING...'
            : this.sourceButton
                .querySelector('.product-buy-buttons--cta-text')
                ?.textContent.trim() || this.sourceButton.textContent.trim();
          if (this.sourcePrice)
            this.price.textContent = this.sourcePrice.textContent.trim();
          this.groups.forEach((group) => {
            group.entries.forEach(({ input, button, swatch }) => {
              button.disabled = input.disabled || input.dataset.empty === 'true';
              button.dataset.unavailable = input.dataset.unavailable || 'false';
              button.setAttribute('aria-pressed', String(input.checked));
              this.copySwatch(input, swatch);
              if (input.checked) {
                group.selectedText.textContent = input.value;
                group.summary.setAttribute('aria-label', `${group.name} ${input.value}`);
                this.copySwatch(input, group.selectedSwatch);
              }
            });
          });
        }

        closeOptions() {
          this.querySelectorAll('details[open]').forEach((details) => {
            details.open = false;
          });
        }

        updateVisibility() {
          this.hidden =
            !this.media.matches ||
            !this.sourceButton.getClientRects().length ||
            this.sourceButton.getBoundingClientRect().bottom >= 0;
          if (this.hidden) this.closeOptions();
        }

        disconnectedCallback() {
          clearTimeout(this.initTimer);
          cancelAnimationFrame(this.syncFrame);
          this.controller?.abort();
          this.observer?.disconnect();
          this.intersection?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    (function () {

  var badgeData = document.querySelector("[data-cs-variant-badges]");
  if (!badgeData) return;

  var variantBadges = JSON.parse(badgeData.textContent);

  function getSelectedVariantId() {

    var variantInput = document.querySelector(
      'form[action*="/cart/add"] [name="id"]'
    );

    return variantInput
      ? String(variantInput.value)
      : null;
  }

  function updateCustomVariantBadge() {

    /* Find the parent price wrapper */
    var priceWrapper = document.querySelector(
      ".product-price--wrapper"
    );

    if (!priceWrapper) {
      return;
    }

    /* Find the existing sale percentage label */
    var saleLabel = priceWrapper.querySelector(
      ".product--label_sale_percent"
    );

    /* Find the custom badge only inside this wrapper */
    var customBadge = priceWrapper.querySelector(
      ".custom-variant-badge"
    );

    /* Create the custom badge if it does not exist */
    if (!customBadge) {

      customBadge = document.createElement("span");

      customBadge.className =
        "custom-variant-badge";

      /*
       * Insert after the sale percentage label.
       * If the sale label does not exist,
       * add the badge inside the price wrapper.
       */
      if (saleLabel) {

        saleLabel.insertAdjacentElement(
          "afterend",
          customBadge
        );

      } else {

        priceWrapper.appendChild(
          customBadge
        );

      }
    }

    /* Get the selected variant */
    var variantId =
      getSelectedVariantId();

    /* Get the custom.badge metafield value */
    var badgeText = variantId
      ? variantBadges[variantId]
      : "";

    /* Hide the badge if the metafield is empty */
    if (
      !badgeText ||
      String(badgeText).trim() === ""
    ) {

      customBadge.textContent = "";
      customBadge.style.display = "none";

      return;
    }

    /* Display the metafield text */
    customBadge.textContent = badgeText;
    customBadge.style.display = "inline-block";
    customBadge.style.background = "#c91e17";
    customBadge.style.color = "#ffffff";
    customBadge.style.border = "1px solid #c91e17";
    customBadge.style.padding = "2px 15px";
    customBadge.style.fontSize = "14px";
    customBadge.style.position = "relative";
    customBadge.style.top = "-3px";
    customBadge.style.lineHeight = "normal";
    customBadge.style.marginLeft = "8px";
  }

  function scheduleBadgeUpdate() {

    setTimeout(
      updateCustomVariantBadge,
      100
    );

  }

  /* Run when the page loads */
  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      updateCustomVariantBadge
    );

  } else {

    updateCustomVariantBadge();

  }

  /* Update when the selected variant changes */
  document.addEventListener(
    "change",
    scheduleBadgeUpdate
  );

  document.addEventListener(
    "variant:change",
    scheduleBadgeUpdate
  );

  document.addEventListener(
    "variantChange",
    scheduleBadgeUpdate
  );

})();
  } catch(e) { console.error(e); }
})();

})();
